import { AttributesMixin, define } from "@type-r/models";
import { CountsModel } from "./countsModel";
import { restfulIO } from "./endpoint";

export interface MultipleAssetsCount extends AttributesMixin<typeof MultipleAssetsCount> { }
@define
export class MultipleAssetsCount extends CountsModel {
    static endpoint = restfulIO('api/v1/ingest/multipleassets/counts');

    static attributes = {
        ...CountsModel.attributes
    };

}
